/**
 * @fileoverview すべての vue インスタンス間でのイベント通知を可能にする結節点 (EventHub) を提供。
 *               これは Vue Plugin であり、 Vue.use() することで利用可能となる。
 * @see https://jp.vuejs.org/v2/guide/migration.html#dispatch-および-broadcast-置き換え
 * @see http://uyamazak.hatenablog.com/entry/2018/04/04/114323
 */

export default {
  install: Vue => {
    const $eventHub = new Vue()

    Object.assign(Vue.prototype, { $eventHub })

    Vue.mixin({
      methods: {
        /**
         * EventHub を介してすべての vue インスタンスへイベントを通知する
         * @param {string} _event         イベント名
         * @param {*}      [_var_args]    引数（任意個数）
         * @return {Vue}
         */
        diffuse (_event, _var_args) {
          $eventHub.$emit.apply($eventHub, arguments)
          return this
        },

        /**
         * EventHub を介してイベントを受け取った時の処理を登録する
         * @param {string}   event       イベント名
         * @param {Function} callback    処理内容
         * @return {Vue}
         */
        received (event, callback) {
          $eventHub.$on(event, callback)
          return this
        },

        /**
         * EventHub を介してイベントを受け取った時に1度だけ実行する処理を登録する
         * @param {string}   event       イベント名
         * @param {Function} callback    処理内容
         * @return {Vue}
         */
        receivedOnce (event, callback) {
          $eventHub.$once(event, callback)
          return this
        },

        /**
         * EventHub を介してイベントを受け取った時の処理を解除する
         * @param {string}   event         イベント名
         * @param {Function} [callback]    処理内容
         * @return {Vue}
         */
        ignoreReceived (event, callback) {
          $eventHub.$off(event, callback)
          return this
        },
      },
    })
  },
}
